import React from 'react';
import DeveloperPlatformIcon from './logo/dpp-icon.png';

const LogoFull = () => {
  return <img src={DeveloperPlatformIcon} width="auto" height="85" />;
};

export default LogoFull;
